import { useAppStore } from '../../../../../store/appStore';
import { stylesheet } from 'typestyle';
import { Blue80 } from '@traceair/tds';

const css = stylesheet({
  highlighted: {
    color: Blue80,
  },
});

interface Props {
  text: string;
}

const cleanUpString = (str: string) => str.trim().toLowerCase().replace(/\s+/g, ' ');

export const MissionCardHighlightSearch = ({ text }: Props) => {
  const { projectSearch } = useAppStore();
  const cleanSearch = cleanUpString(projectSearch ?? '');

  if (cleanSearch.length < 1) {
    return text;
  }

  const cleanSubject = cleanUpString(text);

  const matches: { start: number; end: number }[] = [];
  let startIndex = 0;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const index = cleanSubject.indexOf(cleanSearch, startIndex);
    if (index === -1) break;

    matches.push({
      start: index,
      end: index + cleanSearch.length,
    });

    startIndex = index + cleanSearch.length;
  }

  if (matches.length === 0) {
    return text;
  }

  let result = '';
  let lastEnd = 0;

  for (const match of matches) {
    result += text.substring(lastEnd, match.start);

    result += `<span class="${css.highlighted}">${text.substring(match.start, match.end)}</span>`;

    lastEnd = match.end;
  }

  result += text.substring(lastEnd);

  return <span dangerouslySetInnerHTML={{ __html: result }} />;
};
